import React from "react"
import { Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import employerFlowStyles from "../../styles"

export default function IndustryEligibility(props) {
    const { mode, exitUrl, step, formik } = props
    const { errors, touched } = formik

    const restrictedIndustries = [
        "A money-transfer or check cashing business",
        "A crypto ATM or cash-exchange kiosk",
        "A cannabis business",
        "A payday lender",
        "An adult entertainment business"
    ]
    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>
                    Industry Eligibility
                </Typography>
                <Typography sx={{ marginTop: "20px"}}>
                    I confirm that my business is not in any of the following restricted industries:
                </Typography>

                <Stack component="ul" sx={{ marginTop: "20px", marginBottom: "20px", paddingLeft: "24px" }}>
                    {restrictedIndustries.map((industry, index) => (
                        <Typography component="li" key={index} sx={{ marginBottom: "8px" }}>
                            {industry}
                        </Typography>
                    ))}
                </Stack>

                <Stack direction="row" alignItems="flex-start" spacing={1}>
                    <Field name="industryEligibilityConfirmed">
                        {({ field }) => (
                            <input
                                {...field}
                                type="checkbox"
                                checked={field.value}
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    marginTop: "2px",
                                    accentColor: "#1976d2",
                                    cursor: "pointer"
                                }}
                            />
                        )}
                    </Field>
                    <Typography sx={{ fontSize: "14px" }}>
                        I confirm that my business is not in any of the above listed restricted industries
                    </Typography>
                </Stack>
                {errors.industryEligibilityConfirmed && touched.industryEligibilityConfirmed && (
                    <div className="error-message-fields">{errors.industryEligibilityConfirmed}</div>
                )}
            </FormContainer>

            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
        </Stack>
    )
}